export const primaryDestinations = [
  { path: '/dashboard', label: 'Overview', icon: 'overview' },
  { path: '/activity', label: 'Activity', icon: 'activity' },
  { path: '/plan', label: 'Plan', icon: 'plan' },
  { path: '/account', label: 'Account', icon: 'account' }
] as const;
export type Destination = typeof primaryDestinations[number]['icon'];
export function destinationForPath(path: string): Destination | null {
  if (path === '/dashboard') return 'overview';
  if (path === '/expenses' || path === '/categories' || path === '/activity' || path.startsWith('/activity/')) return 'activity';
  if (path === '/goals' || path === '/credit-cards' || path === '/plan' || path.startsWith('/plan/')) return 'plan';
  if (path === '/settings' || path === '/account' || path.startsWith('/account/')) return 'account';
  return null;
}
export const secondaryDestinations = {
  activity: [
    { path: '/activity/tracked', label: 'Tracked expenses' },
    { path: '/activity/bank', label: 'Bank activity' },
    { path: '/activity/categories', label: 'Categories' }
  ],
  plan: [
    { path: '/plan', label: 'Your plan' },
    { path: '/plan/goals', label: 'Savings goals' },
    { path: '/plan/debt', label: 'Debt repayment' }
  ]
};
export function redirectTarget(path: string, search: string, hash: string) { return path + search + hash; }
